import AbstractRule from './AbstractRule';
import {AnySchema} from 'yup';

export default class NullableRule extends AbstractRule {
    protected name = 'nullable';

    mutateScheme<S extends AnySchema>(scheme: S): S {
        return (scheme.nullable(true) as S).transform(v => (v === '' || Number.isNaN(v) ? null : v));
    }
}
